<template>
  <div class="container-fluid">
    <div class="row flex-md-row flex-column">
      <div class="col-md-4 col-12 custom-col-md-4 d-flex align-items-center">
        <div id="myCarousel" class="carousel slide" data-ride="carousel" v-if="images.length > 1">
          <ol class="carousel-indicators">
            <li
              v-for="(image, index) in images"
              :key="index"
              :data-target="'#myCarousel'"
              :data-slide-to="index"
              :class="{ active: index === 0 }"
            ></li>
          </ol>
          <div class="carousel-inner">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img :src="image" alt="Image" class="d-block w-100" style="object-fit: cover;" />
            </div>
          </div>
          <a class="carousel-control-prev" href="#myCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#myCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
        <div v-else>
          <img :src="images[0]" alt="Image" class="d-block w-100" style="object-fit: cover;" />
        </div>
      </div>
      <div class="col-md-6 col-12 custom-col-md-6">
        <h4>{{ title }}</h4><br />
        <p class="text-dark-gray" v-html="description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        require('@/assets/images/news/24/news_02.jpg'),
        //可輪播圖片
        //EX:require('@/assets/images/news/01/news_3.png'),
      ],
      //標題
      title: '【TSK｜國際注射線上研討會-梁仲斌 醫師】',
      //內文
      description:
        ' <b> 🌏 TSK Expert Webinar Series </b> <br><br>饅化處理的下一步：補充、再生、鬆解，還是觀察？<br>重新評估組織 × 精準注射策略 × 重塑自然光影輪廓<br><br>當臉部填充逐漸失去原有的自然輪廓，甚至出現過度填充、組織膨脹或光影失衡時，下一步該如何選擇？<br>是溶解既有填充物？重新補充流失的支撐？運用膠原蛋白刺激劑改善組織狀態？還是先進行組織鬆解或持續觀察？<br>饅化的處理，不只是減少填充物，更需要重新理解組織狀態與臉部結構。<br><br>本次 TSK 國際注射專家線上研討會，特別邀請 <b>梁仲斌醫師 Dr. Ben Liang</b>，透過臨床經驗與實際案例，分享饅化處理後的組織評估、注射策略及自然輪廓重建的思考方向。<br><br><b>🔍 五大臨床議題</b> <br><br>🔹 溶解｜Dissolve<br> 哪些填充材料可以降解？溶解後，組織真的能回到原本的狀態嗎？<br>🔹 補充｜Refine<br>當組織結構已經改變，如何重新評估支撐需求，規劃精準補充策略？<br>🔹 再生｜Regenerate<br>膠原蛋白刺激劑在饅化後的角色為何？如何評估組織條件與適合的治療時機？<br>🔹 鬆解｜Release<br>什麼情況下需要考慮組織鬆解？如何評估操作層次與相關風險？<br>🔹 觀察｜Observe<br>是否每一種饅化都需要立即處理？哪些情況適合先觀察、追蹤與重新評估？<br><br><b>🎥 真實臨床案例分享</b> <br><br>TSK 22G 鈍針 × Vivabella PDLLA<br>透過中臉光影修飾案例，探討膠原蛋白刺激劑的治療規劃、鈍針操作策略，以及如何從視覺輪廓的角度重新思考饅化問題。<br>不只關注注射材料，更深入探討組織評估、器械選擇與臨床決策之間的關係。<br><br><b>🌏 國際專家線上交流</b> <br><br>從填充物處理到後續注射規劃，與國際專家共同探討不同臨床情境下的治療思維。<br>適合參與對象： 對臉部填充、饅化處理、組織評估、膠原蛋白刺激劑及精準注射策略有興趣的醫師。<br><br><b>📅 研討會資訊</b><br>日期｜2026 年 10 月 27 日（二）<br>時間｜台灣 20:00–21:30<br>形式｜ZOOM 線上講座｜免費報名<br><br><b>🔗 立即報名：</b><br><a href="http://tiny.cc/tskwebinaroct2026" target="_blank" rel="noopener noreferrer"><b>http://tiny.cc/tskwebinaroct2026</b></a>',
    };
  },
};
</script>

<style scoped>
.custom-col-md-4 {
  flex: 0 0 auto;
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-col-md-6 {
  flex: 0 0 auto;
  width: 60%;
}
@media (max-width: 767.98px) {
  .custom-col-md-4,
  .custom-col-md-6 {
    flex: 0 0 auto;
    width: 100%;
  }
}
</style>
